<template>
  <el-badge is-dot :hidden="hasfilter">
    <el-button size="mini" type="info" plain @click="dialog = true">Mais filtros</el-button>
    <el-drawer title="Filtro de Reclamações" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
      ref="drawer" size="50%" :wrapperClosable="false" :append-to-body="true" :modal-append-to-body="false" :modal="true">
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Status">
                <el-radio-group v-model="filter.status">
                  <el-radio label="success">Sucesso</el-radio>
                  <el-radio label="error">Erro</el-radio>
                  <el-radio label="">Ambos</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Objeto">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="$refs.drawer.closeDrawer(); dialog = true">Cancelar</el-button>
          <el-button type="info" @click="
            $refs.drawer.closeDrawer();
          clear();
          ">Limpar filtros</el-button>
          <el-button type="primary" @click="
            $refs.drawer.closeDrawer();
          execute();
          ">Filtrar</el-button>
        </div>
      </div>
    </el-drawer>
  </el-badge>
</template>

<script>
export default {
  props: ["userType"],
  data() {
    return {
      dialog: false,
      filter: {
        tag: "",
        status: "",
      },
    }
  },
  computed: {
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.status
      );
    },
  },
  methods: {
    get() {
      return this.filter;
    },
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    execute() {
      const vm = this;
      vm.$emit("filter");
      vm.dialog = false;
    },
    clear() {
      const vm = this;
      vm.filter.tag = "";
      vm.filter.status = "";
    },
  }
}
</script>